import { InputMask } from "@react-input/mask";

import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ProfileForm } from "@/pages/gate/ProfilesPage";
import { UpdateProfileForm } from "@/pages/gate/UpdateProfilePage";

import { UserInfoForm } from "../modals/UserInfoModal";
import Input from "./Input";

const DateOfBirthInput = () => {
  const {
    setValue,
    clearErrors,
    getValues,
    setError,
    formState: { errors },
  } = useFormContext<ProfileForm | UpdateProfileForm | UserInfoForm>();

  const defValue = getValues("date_of_birth");
  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState(() => {
    if (!defValue) return "";
    const [year, month, day] = defValue.split("-");
    return `${day}-${month}-${year}`;
  });

  const validateInput = (input: string) => {
    const [dayStr, monthStr, yearStr] = input.split("-");
    const day = Number(dayStr);
    const month = Number(monthStr);
    const year = Number(yearStr);
    const currentYear = new Date().getFullYear();

    if (year < 1900 || year > currentYear - 18 || isNaN(year)) {
      setError("date_of_birth", {
        type: "manual",
        message: t("error.enter-valid-year", {
          "year-between": `${1900}-${currentYear - 18}`,
        }),
      });
      return false;
    }

    if (month < 1 || month > 12 || isNaN(month)) {
      setError("date_of_birth", {
        type: "manual",
        message: t("error.enter-valid-month"),
      });
      return false;
    }

    if (day < 1 || day > 31 || isNaN(day)) {
      setError("date_of_birth", {
        type: "manual",
        message: t("error.enter-valid-day"),
      });
      return false;
    }

    clearErrors("date_of_birth");

    const formatted = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    setValue("date_of_birth", formatted, { shouldValidate: true });
    return true;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);

    if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
      validateInput(value);
    } else {
      setError("date_of_birth", {
        type: "manual",
        message: t("error.incomplete-date"),
      });
    }
  };

  const handleBlur = () => {
    if (inputValue && inputValue.length === 10) {
      validateInput(inputValue);
    }
  };

  return (
    <>
      <InputMask
        mask="__-__-____"
        replacement={{ _: /\d/ }}
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        component={Input}
        type="text"
        required
        className="text-on-primary"
        placeholder={t("error.dd-mm-yyyy")}
      />
      <p className="text-error-1">{errors?.date_of_birth?.message}</p>
    </>
  );
};

export default DateOfBirthInput;
